import React, {useEffect, useState} from 'react'
import clsx from 'clsx'
import {useGetAdaptiveStyle, KeyboardIcon, Switch, type StatusType} from 'uikit'
import {config} from 'src/config'
import {useAppDispatch} from 'store'
import {isMobileUserAgent} from 'services/app'
import {activeLetter} from 'store/letter/slice'
import {checkLetterThunk} from 'store/secretword/thunk'
import {getLettersThunk} from 'store/letter/thunk'
import {adaptiveConfigMarginTop} from '../consts'
import {AlphaBetView} from './AlphaBetView'
import {KeyboardView} from './KeyboardView'
import styles from "./letters.scss"

const LettersBox: React.FC = () => {
  const {style, styleHideWhenTooSmallScreen} = useGetAdaptiveStyle([adaptiveConfigMarginTop])
  const idMobile = isMobileUserAgent()
  const dispatch = useAppDispatch()
  const [statusSwitch, setStatusSwitch] = useState<StatusType>(config.letterBoxKeyboard)

  useEffect(() => {
    dispatch(getLettersThunk())
  }, [])

  const handleClick = (newStatus: StatusType) => {
    setStatusSwitch(newStatus)
  }

  const onLetterClick = (letter: string) => {
    dispatch(activeLetter(letter))
    dispatch(checkLetterThunk(letter))
  }

  return (
    <div className={styles.wrap} style={style}>
      {idMobile && <hr className={styles.hrsize} />}
      <div className={styles.switchView} style={styleHideWhenTooSmallScreen}>
        <Switch status={statusSwitch} onClick={handleClick} />
        <div className={clsx(styles.keyboardIcon, statusSwitch !== 'on' && styles.keyboardIconOff)}>
          <KeyboardIcon />
        </div>
      </div>
      {statusSwitch === 'on'
        ? <KeyboardView onLetterClick={onLetterClick} />
        : <AlphaBetView onLetterClick={onLetterClick} />
      }
    </div>
  )
}

export default LettersBox
